import React from 'react';
import styled from 'styled-components';

interface DivBtnNextProps {
  $size?: string;
  $bgColor?: string;
  $hoverColor?: string;
  $positionRight?: string;
  $positionTop?: string;
  $positionLeft?: string;
  $zIndex?: string | number;
}

const DivBtnNext = styled.div<DivBtnNextProps>`
  position: absolute;
  height: ${({ $size }) => $size || '33px'};
  width: ${({ $size }) => $size || '33px'};
  border-radius: 50%;
  background: ${({ $bgColor }) => $bgColor || '#16639b'};
  right: ${({ $positionRight }) => $positionRight || '200px'};
  top: ${({ $positionTop }) => $positionTop || '50%'};
  left: ${({ $positionLeft }) => $positionLeft};  
  transform: translateY(-50%);
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  z-index: ${({ $zIndex }) => $zIndex || '1'};
  transition: background 0.3s ease;
  
  &:hover {
    background: ${({ $hoverColor }) => $hoverColor || '#145b84'};
  }
`;

interface LittleButtonProps extends DivBtnNextProps {
  onClick?: () => void;
  children?: React.ReactNode;
}

const LittleButton: React.FC<LittleButtonProps> = ({
  onClick,
  $size,
  $bgColor,
  $hoverColor,
  $positionRight,
  $positionTop,
  $positionLeft,
  $zIndex,
  children
}) => {
  return (
    <DivBtnNext
      onClick={onClick}
      $size={$size}
      $bgColor={$bgColor}
      $hoverColor={$hoverColor}
      $positionRight={$positionRight}
      $positionTop={$positionTop}
      $positionLeft={$positionLeft}
      $zIndex={$zIndex}
    >
      {children}
    </DivBtnNext>
  );
};

export default LittleButton;
